import type { ReactNode } from 'react';
import { useMemo } from 'react';

import { IconCheckboxButtonsField } from 'components/Form/IconCheckboxButtonsField';
import { useUser } from 'contexts/UserEnvironmentContext';
import { useI18n } from 'i18n/hooks/useI18n';
import { ApiOrgType } from 'modules/listing/orgs/api/types/ApiOrgType';

import { getPreferedListingTypes } from './preferredListingTypes';
import { transformPreferredListingTypesOnChange } from './transformPreferredListingTypesOnChange';

type Props = {
  name: string;
  label?: ReactNode;
  newOrgType?: ApiOrgType | null;
};

export function IconCheckboxListingTypesField({
  name,
  label,
  newOrgType,
}: Props) {
  const { i18n } = useI18n();

  let businessOnlyUser = false;
  const { user } = useUser();
  if (!newOrgType) {
    businessOnlyUser = user
      ? user.orgs.every((org) => org.orgType === ApiOrgType.CORPORATION)
      : false;
  } else if (newOrgType === ApiOrgType.CORPORATION) {
    businessOnlyUser = true;
  }
  const preferredListingTypes = useMemo(
    () => getPreferedListingTypes(i18n, businessOnlyUser),
    [i18n, businessOnlyUser],
  );

  return (
    <IconCheckboxButtonsField
      label={label}
      description={`(${i18n('Not visible to public')})`}
      name={name}
      options={preferredListingTypes}
      transformOnChange={transformPreferredListingTypesOnChange}
    />
  );
}
